// extracted by mini-css-extract-plugin
export var externalLink = "_ai-0";
export var internalLinkLabel = "_ai-1";